// extracted by mini-css-extract-plugin
module.exports = {"moveInSection":"MoveInReady_moveInSection__idvt2","heading":"MoveInReady_heading__7d0QF","intro":"MoveInReady_intro__MKBQy"};